<template>
  <sd-card class="info-box" no-padding :is-grey="isGrey">
    <div v-if="iconType" class="icon-container">
      <app-icon :type="iconType" :width="40" :height="40" />
    </div>
    <h1>{{ title }}</h1>
    <slot></slot>
  </sd-card>
</template>

<style lang="scss" scoped>
.info-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3.5rem 1rem;
  margin: 0;
  border-radius: 0;

  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 80px;
    box-shadow: 0 8px 16px rgba(50, 50, 93, 0.07), 0 2.5px 2.5px rgba(0, 0, 0, 0.06),
      0 -2px 6px rgba(0, 0, 0, 0.04);
    border-radius: 1.5rem;

    .icon {
      font-size: 2.5rem;
    }
  }

  h1 {
    font-size: 27px;
    color: var(--color-grey-700);
    margin: 1.5rem 0;
    font-weight: 700;
  }
}

.is-desktop .info-box {
  padding: 7.5rem 1rem;
  border-radius: 1.5rem;
  max-width: 100%;
  margin: 0 3.5rem;

  h1 {
    font-size: 34px;
    max-width: 700px;
  }

  > :deep(p) {
    max-width: 700px;
  }
}
</style>

<script>
import AppIcon from './AppIcon.vue';
import sdCard from '@smartdesign/vue/components/card';

export default {
  name: 'InfoBox',
  components: {
    sdCard,
    AppIcon,
  },
  props: {
    iconType: {
      type: String,
      default: '',
      required: false,
    },
    title: {
      type: String,
      default: '',
      required: false,
    },
    'is-grey': {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};
</script>
